import React, {useState, useEffect, useReducer} from 'react';
import uuid from 'react-uuid';
import {useParams, useRouteMatch, Link, useLocation, Switch, Route, useHistory} from 'react-router-dom';
import {useLocalStorage} from 'react-use';
import {scheduleReducer, auditReducer} from './Utils/reducer.js';
import {ACTIONS} from './Utils/action.js';
import {useRole} from 'hooks/use-role-hook.js';
import moment from 'moment';
import axios from 'axios';
import AuditContext from './Utils/context.js';

import AuditAdminProof from './Admin/Proof.js';
import AuditAdminEvaluation from './Admin/Evaluation.js';
import AuditAdminVisitation from './Admin/Visitation.js';
import AuditAdminFinding from './Admin/Finding.js';
import AuditAdminReport from './Admin/Report.js';

import AuditAuditeeProof from './Auditee/Proof.js';
import AuditAuditeeEvaluation from './Auditee/Evaluation.js';
import AuditAuditeeVisitation from './Auditee/Visitation.js';
import AuditAuditeeFinding from './Auditee/Finding.js';
import AuditAuditeeReport from './Auditee/Report.js';

import AuditAuditorProof from './Auditor/Proof.js';
import AuditAuditorEvaluation from './Auditor/Evaluation.js';
import AuditAuditorVisitation from './Auditor/Visitation.js';
import AuditAuditorFinding from './Auditor/Finding.js';
import AuditAuditorReport from './Auditor/Report.js';
import natsort from 'hooks/natsort';

import {
  Breadcrumb,
  Card,
  Col,
  Container,
  Form,
  Row,
} from 'react-bootstrap';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bs-stepper/dist/css/bs-stepper.min.css';
import './style.css';

export default function Show() {

  const history = useHistory();

  const { path, url } = useRouteMatch();
  const {role} = useRole();
  const loc = useLocation();
  const {employeeId, scheduleId} = useParams();
  const [auth] = useLocalStorage('authenticated');
  const [audit, dispatchAudit] = useReducer(auditReducer, []);
  const [schedule, dispatchSchedule] = useReducer(scheduleReducer, null);
  const [steps] = useState([
    {
      uuid: uuid(),
      title: 'Proof Submission',
      route: `proofs`,
      // except: schedule?.SHOW_EVALUATE == 1 ? ['auditor','admin'] : ['auditor'],
      except: ['auditor'],
      components: {
        admin: AuditAdminProof,
        auditee: AuditAuditeeProof,
        auditor: AuditAuditorProof,
      }
    },
    {
      uuid: uuid(),
      title: 'Desk Evaluation',
      route: `evaluations`,
      // except: schedule?.SHOW_EVALUATE == 1 ? [''] : ['admin'],
      except: ['admin'],
      components: {
        admin: AuditAdminEvaluation,
        auditee: AuditAuditeeEvaluation,
        auditor: AuditAuditorEvaluation,
      }
    },
    {
      uuid: uuid(),
      title: 'Visitation',
      route: `visitations`,
      except: ['auditee'],
      components: {
        admin: AuditAdminVisitation,
        auditee: AuditAuditeeVisitation,
        auditor: AuditAuditorVisitation,
      }
    },
    {
      uuid: uuid(),
      title: 'List Finding',
      route: `findings`,
      except: ['auditor'],
      components: {
        admin: AuditAdminFinding,
        auditee: AuditAuditeeFinding,
        auditor: AuditAuditorFinding
      }
    },
    {
      uuid: uuid(),
      title: 'Audit Report',
      route: `reports`,
      except: ['auditee', 'auditor'],
      components: {
        admin: AuditAdminReport,
        auditee: AuditAuditeeReport,
        auditor: AuditAuditorReport,
      }
    }
  ]);

  const isComplete = (route) => {

    switch (true) {
      case route === 'proofs' && ['EVALUATED', 'VISITED', 'APPROVED'].includes(schedule.SCHEDULE_STATUS):
        return true;
      case route === 'evaluations' && ['EVALUATED', 'VISITED', 'APPROVED'].includes(schedule.SCHEDULE_STATUS):
        return true;
      case route === 'visitations' && ['APPROVED', 'COMPLETED'].includes(schedule.SCHEDULE_STATUS):
        return true;
      default:
        return false;
    }
  }

  const isCurrentStep = (route) => {
    return loc.pathname.split('/').pop() === route;
  }

  const fetchSchedule = async () => {

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}schedules/${scheduleId}`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          expand: 'instrument.standard,auditee.department,forms.criteria,auditorTeams.auditor.employee',
        }
      });

      dispatchSchedule({
        type: ACTIONS.FETCH,
        payload: {
          ...response.data,
          forms: response.data.forms.sort((a, b) => natsort(a.criteria.CRITERIA_CODE, b.criteria.CRITERIA_CODE))
        },
      });
      // console.log(response.data.SHOW_EVALUATE)
      // if(response.data.SHOW_EVALUATE==1){
      //   steps[1]['except'][0] = '';
      //   steps[0]['except'][1] = 'admin';
      //   console.log(steps);
      // }

    } catch (error) {
      console.log(error);
      alert(`Error`);
    }
  }

  const handleClick = async (e) => {
    e.preventDefault();
    const path = history.location.pathname;
    const myArray = path.split("/");
    if(myArray[1] == 'auditor'){
      return history.push(`/auditor/${auth.employee.EMP_ID}/audits`)
    }else if(myArray[1] == 'auditee'){
      return history.push(`/auditee/${auth.employee.EMP_ID}/audits`)
    }else{
      return history.push(`/admin/schedules`)
    }
  }

  useEffect(() => {
    fetchSchedule();
  }, []);

  useEffect(() => {
    console.log(steps);
  }, [steps]);

  useEffect(() => {
    const userAgent = navigator.userAgent;
    const isSafari = /^((?!chrome|chromium|android|edg).)*safari/i.test(userAgent);

    if (isSafari) {
      alert("For better experience please use chrome instead of safari!!");
    }
  }, []);

  return (
    <AuditContext.Provider value={{
      audit, dispatchAudit,
      schedule, dispatchSchedule,
    }}>
      {schedule !== null ? (
        <Container fluid>
        <Breadcrumb>
          {/* <Breadcrumb.Item onClick={() => history.push(`/${auth.employee.EMP_ID}/audits`)}>
            Audit
          </Breadcrumb.Item> */}
          <Breadcrumb.Item onClick={handleClick}>
            Audit
          </Breadcrumb.Item>
          <Breadcrumb.Item aria-current="page" active>
            {schedule.auditee.department.DEPT_NAME}
          </Breadcrumb.Item>
        </Breadcrumb>
          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <Card.Title as="h4">Audit</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>Auditee</Form.Label>
                        <p>{schedule.auditee.department.DEPT_NAME}</p>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Template</Form.Label>
                        <p>{schedule.instrument.standard.STANDARD_NAME}</p>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Start</Form.Label>
                        <p>{moment(schedule.START_DATE).format('DD MMMM YYYY')}</p>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>End</Form.Label>
                        <p>{moment(schedule.END_DATE).format('DD MMMM YYYY')}</p>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Lead Auditor</Form.Label>
                        <p>
                          <strong>
                          {schedule.auditorTeams && schedule.auditorTeams.map((auditor, key) =>
                          {
                            if(auditor.AUDITOR_TYPE_ID == 2){
                              return auditor.auditor.employee.EMP_NAME;
                            }
                          }
                          )}
                          </strong>
                        </p>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Auditor(s)</Form.Label>
                        <p>
                          {schedule.auditorTeams && schedule.auditorTeams.map((auditor, key) => (
                            auditor.auditor.employee.EMP_NAME + ', '
                          ))}
                        </p>
                      </Form.Group>
                    </Col>
                  </Row>
                    <div style={{display: 'none'}}>
                      {schedule.SHOW_EVALUATE==1
                        ? steps[1]['except'][0]=''
                        : console.log('Hidden Evalute')
                      }
                      {schedule.SHOW_EVALUATE==1
                        ? (steps[0]['except'][1]='admin')
                        : console.log('Hidden Evalute')
                      }
                    </div>
                  <Row>
                    <Col md="12">
                      <div id="progress-stepper" className="bs-stepper vertical">
                        <div className="bs-stepper-header" style={{minWidth: '14rem'}}>
                          {steps && steps.map((step, key) => (
                            <>
                              <div key={key} className={`step ${isCurrentStep(step.route) ? `active` : ``}`} data-target={`#${step.uuid}-tab`}>
                                <Link disabled={step.except?.includes(role)}
                                  to={`${url}/${step.route}`}>
                                  <button role="tab"
                                    disabled={step.except?.includes(role)}
                                    className={`step-trigger ${isComplete(step.route) ? `step-success` : ``}`}
                                    aria-controls={step.uuid} aria-selected={isCurrentStep(step.route)}
                                  >
                                    <span className="bs-stepper-circle">{key + 1}</span>
                                    <span className="bs-stepper-label">{step.title}</span>
                                  </button>
                                </Link>
                              </div>
                              <div className="bs-stepper-line"></div>
                            </>
                          ))}
                        </div>

                        <Switch>
                          <div style={{display: 'flex'}} className="bs-stepper-content">
                            {steps && steps.map((step, key) => (
                              <>
                                <div key={key}
                                  style={{paddingLeft: 0, paddingRight: 0}}
                                  role="tabpanel"
                                  id={`${step.uuid}-tab`}
                                  className={`content ${isCurrentStep(step.route) ? `active` : ``}`}
                                >
                                  <Route key={key} exact path={`${path}/${step.route}`} component={step.components[role]} />
                                </div>
                              </>
                            ))}
                          </div>
                        </Switch>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      ) : <p>Now Loading...</p>}
    </AuditContext.Provider>
  );
}